import { ORGAN_LABELS } from "@/lib/organs";

export default function SampleContent({ detail }) {
  if (!detail?.sample_only) return null;
  return (
    <section data-testid="sample-content" className="space-y-3 text-xs">
      <p className="text-amber-300" data-testid="sample-review-state">
        NEEDS_REVIEW · campione non-HR · nessuna registrazione contabile definitiva.
      </p>
      <p className="text-gray-400">
        Classificazione candidata: {detail.classification?.candidate || "UNKNOWN"}.
        Collegamenti: {(detail.organs || []).map((o) => ORGAN_LABELS[o] || o).join(", ")}.
      </p>
      {detail.classification?.review_note && <p className="text-amber-200" data-testid="sample-classification-review">{detail.classification.review_note}</p>}
      <p className="text-gray-500">Tipo sorgente: {detail.storage_ref?.mime_type || "UNKNOWN"} · copertura: {detail.coverage || "UNKNOWN"}</p>
      <p className="text-gray-500">Questo campione non attesta la completezza dello storico. HR e payroll esclusi.</p>
      {(detail.coverage_limitations || []).map((limit, i) => <p key={i} className="text-amber-300">Copertura mancante: {limit}</p>)}
      {(detail.content_pages || []).map((page, i) => (
        <div key={`${page.part_id}-${page.locator}-${i}`} className="rounded-xl border border-white/10 p-3 space-y-2">
          <div className="text-gray-400 break-all" data-testid="sample-source-reference">
            {page.source} · {page.source_id} · versione {page.source_version} · {page.locator} · parte {page.part_id}
          </div>
          <div className="text-gray-500 break-all">SHA256 originale: {page.original_sha256}</div>
          {page.ocr && <p className="text-amber-200" data-testid="sample-ocr-review">Testo OCR da verificare · {page.ocr.engine} · {page.ocr.low_confidence_words} parole incerte. Nessun importo contabilizzato.</p>}
          {page.coverage === "OCR_REQUIRED"
            ? <p className="text-amber-300">Scansione: OCR qualificato non disponibile, contenuto non letto.</p>
            : <pre className="whitespace-pre-wrap break-words font-sans text-gray-300 max-h-72 overflow-y-auto" data-testid="sample-extracted-text">{page.text || "Nessun testo estraibile."}</pre>}
        </div>
      ))}
    </section>
  );
}
